import React from "react";

function Skill() {
  return (
    <>
      <div className="container-skill" id="skill">
        <h1>Skills</h1>
        <div className="skill-item">
          <div className="skill" data-aos="flip-left" data-aos-duration="1000">
            <img src="html.png" alt="" />
          </div>
          <div className="skill" data-aos="flip-left" data-aos-duration="1000">
          <img src="css.png" alt="" />
          </div>
          <div className="skill" data-aos="flip-left" data-aos-duration="1000">
          <img src="js.png" alt="" />
          </div>
          <div className="skill" data-aos="flip-left" data-aos-duration="1000">
          <img src="react.png" alt="" />
          </div>
          <div className="skill" data-aos="flip-left" data-aos-duration="1000">
          <img src="boot.jpeg" alt="" />
          </div>
          <div className="skill" data-aos="flip-left" data-aos-duration="1000">
          <img src="python.png" alt="" />
          </div>
          <div className="skill" data-aos="flip-left" data-aos-duration="1000">
          <img src="php.png" alt="" />
          </div>
          <div className="skill" data-aos="flip-left" data-aos-duration="1000">
          <img src="cpp.png" alt="" />
          </div>
          
        </div>
      </div>
    </>
  );
}

export default Skill;
